<template>
    <main>
        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-6">
                        <ul class="breadcrumb">
                            <li><a href="/home" title="Home">CNA Box</a></li>
                            <li>Contas Correntes</li>
                        </ul>
                    </section>
                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Contas Correntes</b></h2>
                    </div>

                    <div class="mold-txt-center">
                        <form v-on:submit.prevent="executeFilter(filter)">
                            <div class="row">

                                <div class="form-group col-md-6">
                                    <label for="codigoCedente">Código do Cedente</label>
                                    <input type="text" class="form-control" name="codigoCedente" placeholder="Código do Cedente" v-model="filter.codigoCedente" />
                                </div>

                                <div class="form-group col-md-6">
                                    <label for="carteiraId">Carteira</label>
                                    <select v-select="{ dataitem: 'Carteira', default: 'Todos' }" v-model="filter.carteiraId" class="form-control" name="carteiraId"></select>
                                </div>

                                <div class="form-group col-md-6">
                                    <label>CNAB</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="cNAB" v-model="filter.cnab" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="cNAB" v-model="filter.cnab" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="cNAB" v-model="filter.cnab" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não</span>
                                        </label>
                                    </div>
                                </div>

                                <div class="form-group col-md-6">
                                    <label>Ativa</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ativa" v-model="filter.ativa" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ativa" v-model="filter.ativa" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ativa" v-model="filter.ativa" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não</span>
                                        </label>
                                    </div>
                                </div>

                                <div class="form-group col-md-6">
                                    <label>Principal</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="principal" v-model="filter.principal" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="principal" v-model="filter.principal" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="principal" v-model="filter.principal" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não</span>
                                        </label>
                                    </div>
                                </div>

                                <div class="form-group col-md-6">
                                    <label>Banco Emite Boleto</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="bancoEmite" v-model="filter.bancoEmite" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="bancoEmite" v-model="filter.bancoEmite" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="bancoEmite" v-model="filter.bancoEmite" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não</span>
                                        </label>
                                    </div>
                                </div>

                            </div>
                            <button type="button" class="btn-large-40 btn-red uppercase" @click="executeFilter(filter)">Buscar</button>
                        </form>
                    </div>

                    <div class="table-responsive standard-table header-cinza">
                        <table>
                            <thead>
                                <tr>
                                    <th>#<i @click="executeOrderBy('contaCorrenteCarteiraId')" class="fa fa-sort"></i></th>
                                    <th>Conta<i @click="executeOrderBy('contaCorrente.conta.nome')" class="fa fa-sort"></i></th>
                                    <th>Carteira<i @click="executeOrderBy('carteira.nomeCarteira')" class="fa fa-sort"></i></th>
                                    <th>Código do Cedente<i @click="executeOrderBy('CodigoCedente')" class="fa fa-sort"></i></th>
                                    <th>Taxa do Boleto<i @click="executeOrderBy('TaxaBoleto')" class="fa fa-sort"></i></th>
                                    <th>CNAB<i @click="executeOrderBy('CNAB')" class="fa fa-sort"></i></th>
                                    <th>Ativa<i @click="executeOrderBy('Ativa')" class="fa fa-sort"></i></th>
                                    <th>Principal<i @click="executeOrderBy('Principal')" class="fa fa-sort"></i></th>

                                    <th class="text-center" width="150"><i class="fa fa-cog"></i></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in result.items" v-bind:key="item.tagJobsId" class="animated fadeIn">
                                    <td>{{ item.contaCorrenteCarteiraId }}</td>
                                    <td>{{ item.contaCorrente.conta.nome }}</td>
                                    <td>{{ item.carteira.nomeCarteira }}</td>
                                    <td>{{ item.codigoCedente }}</td>
                                    <td>{{ item.taxaBoleto }}</td>
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.cnab, 'badge-danger': !item.cnab }">{{item.cnab ? 'Sim' : 'Não'}}</span></td>
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.ativa, 'badge-danger': !item.ativa }">{{item.ativa ? 'Sim' : 'Não'}}</span></td>
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.principal, 'badge-danger': !item.principal }">{{item.principal ? 'Sim' : 'Não'}}</span></td>
                                    <td class="text-center">
                                        <button type="button" class="btn btn-sm btn-success" v-b-tooltip title="Editar" @click="openAtualizaDadosBancarios({ contaCorrenteCarteiraId: item.contaCorrenteCarteiraId })">
                                            <i class="fa fa-refresh"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-primary" v-b-tooltip title="Remover" @click="openEdit({ contaCorrenteCarteiraId: item.contaCorrenteCarteiraId })">
                                            <i class="fa fa-pencil"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="card-block no-padding">
                        <pagination :total="result.total" :page-size="filter.pageSize" :callback="executePageChanged"></pagination>
                    </div>

                </div>
            </div>
        </section>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" size="lg" centered v-model="dialogEdit" :hide-footer="true" title="Editar">
            <form-edit v-if="dialogEdit" :id="contaCorrenteCarteiraId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogRemove" title="Confirmação">
            <p>Tem certeza que deseja remover este item?</p>
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="executeRemove()">
                    Remover
                </button>
            </div>
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogAtualizaDadosBancarios" title="Confirmação">
            <p>Tem certeza que deseja atualizar todos os boletos pendentes com os dados atuais desta conta corrente?</p>
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="executeAtulizarDadosBancarios()">
                    Atualizar
                </button>
            </div>
        </b-modal>

    </main>

</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    import formCreate from './form-create'
    import formEdit from './form-edit'

    export default {
        name: 'contacorrentecarteira',
        mixins: [base],
        components: { formCreate, formEdit },
        data() {
            return {

                resources: {
                    filter: 'contacorrentecarteira',
                    remove: 'contacorrentecarteira'
                },

                dialogAtualizaDadosBancarios: false,
                dialogRemove: false,
                dialogCreate: false,
                dialogEdit: false,

                model: {},
                filter: {
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                    carteiraId:""
                },

                result: {
                    total: 0,
                    items: []
                }
            }
        },
        methods: {
            openEdit: function (model) {
                this.contaCorrenteCarteiraId = model.contaCorrenteCarteiraId;
                this.dialogEdit = true;
            },
            openCreate: function () {
                this.dialogCreate = true;
            },
            onSaved: function () {
                this.hideAll();
                this.executeLoad();
            },
            hideAll: function () {
                this.dialogCreate = false;
                this.dialogEdit = false;
                this.dialogRemove = false;
                this.dialogAtualizaDadosBancarios = false;
            },

            openAtualizaDadosBancarios: function (model) {
                this.dialogAtualizaDadosBancarios = true;
                this.model = model;
            },

            openRemove: function (model) {
                this.dialogRemove = true;
                this.model = model;
            },
            executeAtulizarDadosBancarios: function (model) {
                if (model)
                    this.model = model;

                this.model.atualizaDadosBancarios = true;
                new Api("contacorrentecarteira/atualizadadosbancarios").post(this.model).then(() => {
                    this.model.AtualizaDadosBancarios = false;
                    this.defaultSuccessResult("Item atualizado com sucesso");
                    this.hideAll();
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },
            executeRemove: function (model) {
                if (model) this.model = model;
                new Api(this.resources.remove).delete(this.model).then(() => {
                    this.defaultSuccessResult("Item removido com sucesso");
                    this.hideAll();
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            executeFilter: function (filter) {
                if (filter) this.filter = filter;
                this.executeLoad();
            },
            executePageChanged: function (index) {
                this.filter = this.defaultPageChanged(this.filter, index);
                this.executeLoad();
            },
            executeOrderBy: function (field) {
                this.filter = this.defaultOrderBy(this.filter, field);
                this.executeLoad();
            },
            executeLoad: function () {
                this.showLoading();
                new Api(this.resources.filter).get(this.filter).then(data => {
                    if (data.summary) this.result.total = data.summary.total;
                    this.result.items = data.dataList;
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },

        },

        mounted() {
            this.executeFilter();
        }

    };
</script>